module.exports = __webpack_public_path__ + "static/media/loading.c932390d.gif";